// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Styles_fadeIn__2qqC3","container":"Styles_container__1w1mb","image":"Styles_image__3xNhy"};